// eslint-disable-next-line simple-import-sort/imports
import React from 'react';
import { IndexRoute, Route, Router } from 'react-router';

import AdminsContainer from './components/Admins/components/AdminsContainer';
import MyAccount from './components/Admins/components/MyAccount';
import AssignmentsByWriter from './components/Assignments/components/AssignmentsByWriter/AssignmentsByWriterContainer';
/** *******
 * Pages *
 ******** */
//* * Assignments
import AssignmentsPage from './components/Assignments/components/AssignmentsPage';
import BannersPage from './components/Banners/BannersContainer';
import BibliographiesContainer from './components/Bibliographies/components/BibliographiesContainer';
//* * Books
import BooksContainer from './components/Books/components/BooksContainer';
// ** Customer Submission */
import CustomerSubmissionPage from './components/CustomerSubmission/CustomerSubmissionContainer';
import CyclesContainer from './components/Cycles/components/CyclesContainer';
import GroupsContainer from './components/Groups/components/GroupsContainer';
//* * Simple pages
import LoginContainer from './components/Login/components/LoginContainer';
import Logout from './components/Logout/Logout';
import MessageCenterPage from './components/MessageCenter/messageCenterContainer';
//* *  New Coupons
import newCoupons from './components/NewCoupons/newCoupons';
import PermissionsPage from './components/Permissions/components/PermissionsContainer';
//* * Practice Exams
import PracticeExamsContainer from './components/PracticeExams/components/PracticeExamsContainer';
import PromptsPage from './components/Prompts/PromptsContainer';
//* * Quals
// import QualsPage from './components/Quals/components/QualsPage';
// import ReferencesContainer from './components/References/components/ReferencesContainer';
//* * Questions
import QuestionsContainer from './components/Questions/components/QuestionsContainer';
import ReportsPage from './components/Reports/components/ReportsContainer';
import ResetPassword from './components/ResetPassword/components/ResetPasswordContainer';
import RolesContainer from './components/Roles/components/RolesContainer';
//* * Search
import SearchContainer from './components/Search/components/SearchContainer';
import SettingsPage from './components/Settings/components/SettingsContainer';
//* * Settings
import DailyQuizContainer from './components/DailyQuiz/DailyQuizContainer';
import StudyProgramsPage from './components/StudyPrograms/StudyProgramsContainer';
import AudioGenerationQueueContainer from './components/AudioGenerationQueue/AudioGenerationQueueContainer';
import AudioAbbreviationsContainer from './components/AudioAbbreviations/AudioAbbreviationsContainer';
import SelfPromotionContainer from './components/SelfPromotion/components/SelfPromotionContainer';

import AbbreviationsQueueContainer from './components/AudioGenerationQueue/AbbreviationsQueueContainer';
import UsersContainer from './components/Users/components/UsersContainer';
import ForgotPassword from './containers/forgotPasswordContainer';
/** ************
 * Containers *
 ************* */
import Full from './containers/Full';
import MaintenanceContainer from './containers/maintenanceContiner';
import Simple from './containers/Simple';
/** *********
 * HEADERS *
 ********** */
import * as headerOptions from './HeaderOptions';
/** *************
 * MIDDLEWARES *
 ************** */
import { checkAuthorization, checkLoginAuthorization } from './lib/check-auth';
import Loading from './components/Pages/Loading/Loading';
import Page401 from './components/Pages/Page401/Page401';
import Page404 from './components/Pages/Page404';
import Page500 from './components/Pages/Page500';

function onEnter(store, name) {
  return checkAuthorization(store, name);
}

function AppRouter(store) {
  if (process.env.REACT_APP_ON_MAINTENANCE === 'true') {
    return (
      <Route path="*" name="Maintenance" component={MaintenanceContainer} />
    );
  }
  return (
    <Router>
      <Route path="home" name="Home" component={Full}>
        {/* MY-ACCOUNT */}
        <Route
          path="my-account"
          name="my-account"
          header={headerOptions.missionControl}
          component={MyAccount}
        >
          {' '}
        </Route>
        <Route
          path="mission-control"
          name="MissionControl"
          header={headerOptions.missionControl}
        >
          <Route
            path="cycles"
            onEnter={onEnter(store, 'MissionControl.Cycles')}
            name="MissionControl.Cycles"
            component={CyclesContainer}
          />
          {/* <Route
            path="assignments"
            onEnter={onEnter(store, 'MissionControl.Assignments')}
            name="MissionControl.Assignments"
            component={AssignmentsPage}
          /> */}
          <Route
            path="writers"
            onEnter={onEnter(store, 'MissionControl.Writers')}
            name="MissionControl.Writers"
            component={AssignmentsByWriter}
          />

          <Route
            path="reports"
            onEnter={onEnter(store, 'MissionControl.Reports')}
            name="MissionControl.Reports"
            component={ReportsPage}
          />

          <Route
            path="message-center"
            onEnter={onEnter(store, 'MissionControl.MessageCenter')}
            name="MissionControl.MessageCenter"
            component={MessageCenterPage}
          />

          <Route
            path="customer-submission"
            onEnter={onEnter(store, 'MissionControl.CustomerSubmission')}
            name="MissionControl.CustomerSubmission"
            component={CustomerSubmissionPage}
          />
        </Route>

        {/* ACCOUNTS */}
        <Route
          path="accounts"
          name="Accounts"
          header={headerOptions.missionControl}
        >
          <Route
            path="students"
            onEnter={onEnter(store, 'Accounts.Students')}
            name="Accounts.Students"
            component={UsersContainer}
            header={headerOptions.missionControl}
          />
          <Route path="admins">
            <IndexRoute
              onEnter={onEnter(store, 'Accounts.Admins')}
              name="Accounts.Admins.List"
              component={AdminsContainer}
              header={headerOptions.missionControl}
            />
          </Route>

          <Route
            path="roles"
            onEnter={onEnter(store, 'Accounts.Roles')}
            name="Accounts.Roles"
            component={RolesContainer}
            header={headerOptions.missionControl}
          />

          <Route
            path="teams"
            onEnter={onEnter(store, 'Accounts.Teams')}
            name="Accounts.Teams"
            component={GroupsContainer}
          />
        </Route>

        {/* QUALS */}
        {/* <Route
          path="quals"
          header={headerOptions.missionControl}
          onEnter={onEnter(store, 'Quals')}
          name="Quals"
          component={QualsPage}
        /> */}

        {/* BOOKS */}
        <Route
          path="books"
          header={headerOptions.missionControl}
          name="Books"
          component={BooksContainer}
          onEnter={onEnter(store, 'Books')}
        />

        {/* QUESTIONS (SHOW A SPECIFIC QUESTION) */}
        <Route
          path="questions"
          name="Question Overview"
          header={headerOptions.questions}
        >
          <Route
            onEnter={onEnter(store, 'Books.Questions')}
            header={headerOptions.questions}
            name="Questions"
            component={QuestionsContainer}
          />
          <Route
            onEnter={onEnter(store, 'Books.Questions')}
            path=":reference/:chapter/:rate/:isQual"
            header={headerOptions.questions}
            name="Questions"
            component={QuestionsContainer}
          />
        </Route>

        {/* BIBLIOGRAPHY */}
        <Route
          path="bibliographies"
          header={headerOptions.missionControl}
          name="Bibliographies"
          component={BibliographiesContainer}
          onEnter={onEnter(store, 'Bibliographies')}
        />

        {/* PRACTICE EXAMS */}
        <Route
          path="practice-exams"
          header={headerOptions.missionControl}
          name="PracticeExams"
          component={PracticeExamsContainer}
          onEnter={onEnter(store, 'PracticeExams')}
        />

        {/* SEARCH */}
        <Route
          path="search"
          header={headerOptions.missionControl}
          name="Search"
          component={SearchContainer}
          onEnter={onEnter(store, 'Search')}
        />

        {/* SETTINGS */}
        <Route
          path="settings"
          name="Settings"
          header={headerOptions.missionControl}
        >
          <Route
            path="keys"
            onEnter={onEnter(store, 'Settings.Keys')}
            name="Settings.Keys"
            header={headerOptions.missionControl}
            component={SettingsPage}
          />
          <Route
            path="permissions"
            onEnter={onEnter(store, 'Settings.Permissions')}
            name="Settings.Permissions"
            component={PermissionsPage}
            header={headerOptions.missionControl}
          />
          <Route
            path="banners"
            onEnter={onEnter(store, 'Settings.Banners')}
            name="Settings.Banners"
            component={BannersPage}
            header={headerOptions.missionControl}
          />
          <Route
            path="rates"
            onEnter={onEnter(store, 'Settings.AFSCs')}
            name="Settings.AFSCs"
            header={headerOptions.missionControl}
            component={StudyProgramsPage}
          />
          <Route
            path="newCoupons"
            onEnter={onEnter(store, 'Settings.Coupons')}
            name="Settings.Coupons"
            header={headerOptions.missionControl}
            component={newCoupons}
          />
          <Route
            path="prompts"
            onEnter={onEnter(store, 'Settings.Prompts')}
            name="Settings.Prompts"
            component={PromptsPage}
            header={headerOptions.missionControl}
          />
          <Route
            path="dailyQuiz"
            onEnter={onEnter(store, 'Settings.DailyQuiz')}
            name="Settings.DailyQuiz"
            component={DailyQuizContainer}
            header={headerOptions.missionControl}
          />
          <Route
            path="audioGenerationQueue"
            onEnter={onEnter(store, 'Settings.AudioGenerationQueue')}
            name="Settings.AudioGenerationQueue"
            component={AudioGenerationQueueContainer}
            header={headerOptions.missionControl}
          />
          <Route
            path="audioAbbreviations"
            onEnter={onEnter(store, 'Settings.AudioAbbreviations')}
            name="Settings.AudioAbbreviations"
            component={AudioAbbreviationsContainer}
            header={headerOptions.missionControl}
          />
          <Route
            path="abbreviationsQueue"
            onEnter={onEnter(store, 'Settings.AudioAbbreviationsQueue')}
            name="Settings.AudioAbbreviationsQueue"
            component={AbbreviationsQueueContainer}
            header={headerOptions.missionControl}
          />
          <Route
            path="selfPromotion"
            onEnter={onEnter(store, 'Settings.SelfPromotion')}
            name="Settings.SelfPromotion"
            component={SelfPromotionContainer}
            header={headerOptions.missionControl}
          />
        </Route>
      </Route>

      <Route path="/" name="Pages" component={Simple}>
        <IndexRoute
          onEnter={checkLoginAuthorization(store)}
          component={LoginContainer}
        />
        <Route
          path="login"
          name="Login Page"
          component={LoginContainer}
          onEnter={checkLoginAuthorization(store)}
        />
        <Route
          path="/forgot-password"
          name="ForgotPassword"
          component={ForgotPassword}
        />
        <Route
          path="/password-reset"
          name="ResetPassword"
          component={ResetPassword}
        />
        <Route path="401" name="Page 401" component={Page401} />
        <Route path="loading" name="Loading" component={Loading} />
        <Route path="500" name="Page 500" component={Page500} />
        <Route path="logout" name="Logout" component={Logout} />
        <Route
          path="maintenance"
          name="Maintenance"
          component={MaintenanceContainer}
        />
      </Route>
      <Route path="*" name="Page 404" component={Page404} />
    </Router>
  );
}

export default AppRouter;
